import clsx from 'clsx';
import { PhonicsLessonGroup } from '@/api/types';

interface ManageGroupSelectProps {
  className?: string;
  lessonGroups: Array<PhonicsLessonGroup>;
  currentGroup?: PhonicsLessonGroup;
  onChange: (group?: PhonicsLessonGroup) => void;
}

export const ManageGroupSelect = ({
  className,
  lessonGroups,
  currentGroup,
  onChange,
}: ManageGroupSelectProps) => (
  <select
    className={clsx('p-3', className)}
    onChange={(e) =>
      onChange(
        lessonGroups
          .flatMap((yearGroup) => yearGroup.children || [])
          .find((group) => e.target.value === group.id),
      )
    }
  >
    {lessonGroups?.map((yearGroup) => (
      <optgroup key={yearGroup.id} label={yearGroup.name}>
        {yearGroup.children?.map((group) => (
          <option
            key={group.id}
            value={group.id}
            selected={currentGroup && currentGroup.id === group.id}
          >
            {group.name}
          </option>
        ))}
      </optgroup>
    ))}
  </select>
);
